import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {UserCancelDataService} from "../../services/user-cancel-data.service";
import {toSignal} from "@angular/core/rxjs-interop";
import {DatePipe} from "@angular/common";
import {PrimeTemplate} from "primeng/api";
import {TableModule} from "primeng/table";
import {TypedTableRowDirective} from "../../typed-table-row.directive";
import {UserCancelDto} from "admin-api-dto";

@Component({
  selector: 'app-cancel-tab',
  imports: [
    DatePipe,
    PrimeTemplate,
    TableModule,
    TypedTableRowDirective
  ],
  templateUrl: './cancel-tab.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CancelTabComponent {
  private readonly userCancelDataService = inject(UserCancelDataService);

  private readonly initialCancelData: UserCancelDto[] = [];
  protected readonly cancelData = toSignal(this.userCancelDataService.getCancelDate(), {
    initialValue: this.initialCancelData
  })

}
